"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable react/function-component-definition */
/* eslint-disable react/require-default-props */
const react_1 = __importDefault(require("react"));
const BOMItem_1 = __importDefault(require("../BOMItem"));
const BOMItemsGroup_scss_1 = __importDefault(require("./BOMItemsGroup.scss"));
const BOMItemsGroup = ({ group: { items, name }, lineItemNumbers, sizePrecision, isSearchActive = false, searchText = '', }) => {
    return items.length > 0 ? (react_1.default.createElement("div", { className: BOMItemsGroup_scss_1.default.group },
        react_1.default.createElement("div", { className: BOMItemsGroup_scss_1.default.title }, name),
        react_1.default.createElement("div", null, items.map((item) => {
            var _a;
            const shouldExpandServices = Boolean(isSearchActive &&
                searchText &&
                ((_a = item.services) === null || _a === void 0 ? void 0 : _a.some((service) => {
                    var _a, _b;
                    return ((_a = service.description) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(searchText.toLowerCase())) ||
                        ((_b = service.item_number) === null || _b === void 0 ? void 0 : _b.toString().toLowerCase().includes(searchText.toLowerCase()));
                })));
            return (react_1.default.createElement("div", { key: item.id },
                react_1.default.createElement(BOMItem_1.default, { item: item, sizePrecision: sizePrecision, forceExpand: shouldExpandServices, lineItemNumber: lineItemNumbers.get(item.id) })));
        })))) : null;
};
exports.default = BOMItemsGroup;
